import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

export default function BewerbenPage() {
  const { subdomain } = useParams<{ subdomain: string }>();
  const [companyName, setCompanyName] = useState<"" | null>(null);
  const [jobs, setJobs] = useState<string[]>([]);

  const fetchData = async () => {
    try {
      const companyInfo = await fetch(
        `${process.env.REACT_APP_API_URL}/companies/public/${subdomain}`,
      );
      const data = await companyInfo.json();
      if (data?.company?.name) {
        setCompanyName(data.company.name);
      }

      const jobData = await fetch(
        `${process.env.REACT_APP_API_URL}/companies/getConfig/${subdomain}`,
      );
      const jobTitles = await jobData.json();
      setJobs(jobTitles.jobTitles.map((j: any) => j.job_title));
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [subdomain]);

  const [form, setForm] = useState({
    anrede: "",
    vorname: "",
    nachname: "",
    email: "",
    telefon: "",
    stelle: "",
    motivationsschreiben: "",
  });
  const [file, setFile] = useState<File[]>([]);
  const [submitted, setSubmitted] = useState(false);
  const [dragOver, setDragOver] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >,
  ) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const filesBase64 = await Promise.all(
        file.map(
          (singleFile) =>
            new Promise<{ base64: string; type: string; name: string }>(
              (resolve) => {
                const reader = new FileReader();
                reader.onload = () => {
                  const result = reader.result as string;
                  resolve({
                    base64: result.split(",")[1],
                    type: singleFile.type,
                    name: singleFile.name,
                  });
                };
                reader.readAsDataURL(singleFile);
              },
            ),
        ),
      );

      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/companies/submit`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            ...form,
            company_subdomain: subdomain,
            files: filesBase64,
          }),
        },
      );

      const data = await res.json();
      if (data.success) {
        setSubmitted(true);
      } else {
        alert("Fehler: " + data.error);
      }
    } catch (err) {
      console.error(err);
      alert("Fehler beim Absenden");
    } finally {
      setLoading(false);
    }
  };

  if (submitted) {
    return (
      <>
        <style>{`
          @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=DM+Sans:wght@300;400;500;600&display=swap');
          * { box-sizing: border-box; margin: 0; padding: 0; }
          body { background: #f7f6f3; }
        `}</style>
        <div
          style={{
            minHeight: "100vh",
            background: "#f7f6f3",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            fontFamily: "'DM Sans', sans-serif",
            padding: "24px",
          }}
        >
          <div style={{ textAlign: "center", maxWidth: "440px" }}>
            <div
              style={{
                width: "64px",
                height: "64px",
                background: "#1a1a1a",
                borderRadius: "50%",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 28px",
                fontSize: "1.4rem",
                color: "#fff",
              }}
            >
              ✓
            </div>
            <h2
              style={{
                fontFamily: "'Playfair Display', serif",
                fontSize: "2rem",
                fontWeight: 700,
                color: "#1a1a1a",
                marginBottom: "14px",
                letterSpacing: "-0.02em",
              }}
            >
              Bewerbung eingegangen
            </h2>
            <p
              style={{ color: "#6b6b6b", lineHeight: 1.7, fontSize: "0.95rem" }}
            >
              Vielen Dank für deine Bewerbung bei{" "}
              <strong style={{ color: "#1a1a1a" }}>{companyName ?? ""}</strong>.
              Wir melden uns in Kürze bei dir.
            </p>
            <div
              style={{
                marginTop: "48px",
                paddingTop: "24px",
                borderTop: "1px solid #e8e6e0",
                fontSize: "0.75rem",
                color: "#aaa",
                letterSpacing: "0.04em",
              }}
            >
              Powered by <strong style={{ color: "#1a1a1a" }}>HireHero</strong>
            </div>
          </div>
        </div>
      </>
    );
  }

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@600;700&family=DM+Sans:wght@300;400;500;600&display=swap');
        * { box-sizing: border-box; margin: 0; padding: 0; }
        body { background: #f7f6f3; }

        .bew-page {
          min-height: 100vh;
          background: #f7f6f3;
          font-family: 'DM Sans', sans-serif;
          color: #1a1a1a;
        }

        /* Left sidebar */
        .bew-layout {
          display: grid;
          grid-template-columns: 340px 1fr;
          min-height: 100vh;
        }

        .bew-sidebar {
          background: #1a1a1a;
          color: #fff;
          padding: 48px 40px;
          display: flex;
          flex-direction: column;
          position: sticky;
          top: 0;
          height: 100vh;
        }

        .bew-main {
          padding: 48px 56px;
          max-width: 640px;
        }

        .bew-label {
          display: block;
          font-size: 0.72rem;
          font-weight: 600;
          color: #888;
          letter-spacing: 0.08em;
          text-transform: uppercase;
          margin-bottom: 8px;
        }

        .bew-input, .bew-select, .bew-textarea {
          width: 100%;
          background: #fff;
          border: 1.5px solid #e8e6e0;
          border-radius: 10px;
          padding: 12px 16px;
          color: #1a1a1a;
          font-family: 'DM Sans', sans-serif;
          font-size: 0.9rem;
          outline: none;
          transition: border-color 0.2s, box-shadow 0.2s;
          appearance: none;
        }
        .bew-input:focus, .bew-select:focus, .bew-textarea:focus {
          border-color: #1a1a1a;
          box-shadow: 0 0 0 3px rgba(26,26,26,0.06);
        }
        .bew-input::placeholder, .bew-textarea::placeholder { color: #bbb; }
        .bew-select option { background: #fff; color: #1a1a1a; }
        .bew-textarea {
          resize: vertical;
          min-height: 130px;
          line-height: 1.6;
        }

        .two-col {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 16px;
        }

        .field-wrap { margin-bottom: 22px; }

        .drop-zone {
          border: 1.5px dashed #d4d1c9;
          border-radius: 10px;
          padding: 28px;
          text-align: center;
          cursor: pointer;
          transition: all 0.2s;
          background: #fff;
          display: block;
        }
        .drop-zone:hover, .drop-zone.active {
          border-color: #1a1a1a;
          background: #fafaf8;
        }

        .btn-submit {
          width: 100%;
          background: #1a1a1a;
          color: #fff;
          border: none;
          border-radius: 10px;
          padding: 15px 28px;
          font-family: 'DM Sans', sans-serif;
          font-size: 0.95rem;
          font-weight: 600;
          cursor: pointer;
          transition: opacity 0.2s, transform 0.1s;
          letter-spacing: 0.01em;
        }
        .btn-submit:hover { opacity: 0.85; }
        .btn-submit:active { transform: scale(0.99); }
        .btn-submit:disabled { opacity: 0.5; cursor: not-allowed; }

        .divider {
          border: none;
          border-top: 1px solid #e8e6e0;
          margin: 32px 0;
        }

        @media (max-width: 780px) {
          .bew-layout { grid-template-columns: 1fr; }
          .bew-sidebar { position: static; height: auto; padding: 32px 24px; }
          .bew-main { padding: 32px 24px; max-width: 100%; }
          .two-col { grid-template-columns: 1fr; }
        }
      `}</style>

      <div className="bew-page">
        <div className="bew-layout">
          {/* Sidebar */}
          <div className="bew-sidebar">
            <div style={{ marginBottom: "auto" }}>
              <h1
                style={{
                  fontFamily: "'Playfair Display', serif",
                  fontSize: "2rem",
                  fontWeight: 700,
                  lineHeight: 1.2,
                  letterSpacing: "-0.02em",
                  marginBottom: "16px",
                  color: "#fff",
                }}
              >
                {companyName ?? <span style={{ opacity: 0.3 }}>Laden...</span>}
              </h1>

              <p
                style={{
                  color: "rgba(255,255,255,0.45)",
                  fontSize: "0.9rem",
                  lineHeight: 1.7,
                }}
              >
                Bewirb dich jetzt und wir melden uns in Kürze bei dir.
              </p>

              {/* Steps */}
              <div style={{ marginTop: "48px" }}>
                {["Persönliche Daten", "Unterlagen hochladen", "Absenden"].map(
                  (step, i) => (
                    <div
                      key={i}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "14px",
                        marginBottom: "16px",
                      }}
                    >
                      <div
                        style={{
                          width: "26px",
                          height: "26px",
                          border: "1.5px solid rgba(255,255,255,0.2)",
                          borderRadius: "50%",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "0.72rem",
                          fontWeight: 600,
                          color: "rgba(255,255,255,0.4)",
                          flexShrink: 0,
                        }}
                      >
                        {i + 1}
                      </div>
                      <span
                        style={{
                          fontSize: "0.85rem",
                          color: "rgba(255,255,255,0.4)",
                        }}
                      >
                        {step}
                      </span>
                    </div>
                  ),
                )}
              </div>
            </div>

            <div
              style={{
                paddingTop: "32px",
                borderTop: "1px solid rgba(255,255,255,0.08)",
                fontSize: "0.72rem",
                color: "rgba(255,255,255,0.2)",
                letterSpacing: "0.04em",
              }}
            >
              Powered by{" "}
              <span style={{ color: "rgba(255,255,255,0.5)" }}>HireHero</span>
            </div>
          </div>

          {/* Main Form */}
          <div className="bew-main">
            <h2
              style={{
                fontFamily: "'Syne', sans-serif",
                fontSize: "1.5rem",
                fontWeight: 800,
                letterSpacing: "-0.02em",
                marginBottom: "32px",
                color: "#1a1a1a",
              }}
            >
              Bewerbungsformular
            </h2>

            {/* Stelle */}
            <div className="field-wrap">
              <span className="bew-label">Stelle *</span>
              <div style={{ position: "relative" }}>
                <select
                  className="bew-select"
                  name="stelle"
                  value={form.stelle}
                  onChange={handleChange}
                >
                  <option value="">Stelle auswählen...</option>
                  {jobs.map((job, index) => (
                    <option key={index} value={job}>
                      {job}
                    </option>
                  ))}
                </select>
                <span
                  style={{
                    position: "absolute",
                    right: "14px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#999",
                    pointerEvents: "none",
                    fontSize: "0.75rem",
                  }}
                >
                  ▾
                </span>
              </div>
            </div>

            <hr className="divider" />

            {/* Anrede */}
            <div className="field-wrap">
              <span className="bew-label">Anrede *</span>
              <div style={{ position: "relative" }}>
                <select
                  className="bew-select"
                  name="anrede"
                  value={form.anrede}
                  onChange={handleChange}
                >
                  <option value="">Bitte wählen...</option>
                  <option value="Herr">Herr</option>
                  <option value="Frau">Frau</option>
                  <option value="Divers">Divers</option>
                  <option value="Keine Angabe">Keine Angabe</option>
                </select>
                <span
                  style={{
                    position: "absolute",
                    right: "14px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    color: "#999",
                    pointerEvents: "none",
                    fontSize: "0.75rem",
                  }}
                >
                  ▾
                </span>
              </div>
            </div>

            {/* Name */}
            <div className="two-col field-wrap">
              <div>
                <span className="bew-label">Vorname *</span>
                <input
                  className="bew-input"
                  name="vorname"
                  placeholder="Anna"
                  value={form.vorname}
                  onChange={handleChange}
                />
              </div>
              <div>
                <span className="bew-label">Nachname *</span>
                <input
                  className="bew-input"
                  name="nachname"
                  placeholder="Müller"
                  value={form.nachname}
                  onChange={handleChange}
                />
              </div>
            </div>

            {/* Kontakt */}
            <div className="two-col field-wrap">
              <div>
                <span className="bew-label">E-Mail *</span>
                <input
                  className="bew-input"
                  name="email"
                  type="email"
                  placeholder="anna@email.at"
                  value={form.email}
                  onChange={handleChange}
                />
              </div>
              <div>
                <span className="bew-label">Telefon *</span>
                <input
                  className="bew-input"
                  name="telefon"
                  placeholder="+43 123 456 789"
                  value={form.telefon}
                  onChange={handleChange}
                />
              </div>
            </div>

            <hr className="divider" />

            {/* Lebenslauf Upload */}
            <div className="field-wrap">
              <span className="bew-label">Lebenslauf *</span>
              <label
                className={`drop-zone${dragOver ? " active" : ""}`}
                onDragOver={(e) => {
                  e.preventDefault();
                  setDragOver(true);
                }}
                onDragLeave={() => setDragOver(false)}
                onDrop={(e) => {
                  e.preventDefault();
                  setDragOver(false);
                  setFile(Array.from(e.dataTransfer.files));
                }}
              >
                <input
                  type="file"
                  accept=".pdf,.docx"
                  multiple
                  style={{ display: "none" }}
                  onChange={(e) => {
                    if (e.target.files) {
                      setFile((prev) => [
                        ...prev,
                        ...Array.from(e.target.files!),
                      ]);
                    }
                  }}
                />
                {file.length > 0 ? (
                  <div>
                    <div style={{ fontSize: "1.4rem", marginBottom: "6px" }}>
                      📄
                    </div>
                    <p
                      style={{
                        color: "#1a1a1a",
                        fontWeight: 600,
                        fontSize: "0.88rem",
                      }}
                    >
                      {file.map((f) => f.name).join(", ")}
                    </p>
                    <p
                      style={{
                        color: "#aaa",
                        fontSize: "0.78rem",
                        marginTop: "4px",
                      }}
                    >
                      Klicken um zu ändern
                    </p>
                  </div>
                ) : (
                  <div>
                    <div
                      style={{
                        fontSize: "1.4rem",
                        marginBottom: "8px",
                        color: "#bbb",
                      }}
                    >
                      ↑
                    </div>
                    <p
                      style={{
                        color: "#555",
                        fontSize: "0.88rem",
                        fontWeight: 500,
                      }}
                    >
                      PDF oder DOCX hochladen
                    </p>
                    <p
                      style={{
                        color: "#bbb",
                        fontSize: "0.78rem",
                        marginTop: "4px",
                      }}
                    >
                      oder hier reinziehen
                    </p>
                  </div>
                )}
              </label>
            </div>

            <button
              className="btn-submit"
              onClick={handleSubmit}
              disabled={loading}
            >
              {loading ? "Wird gesendet..." : "Bewerbung absenden →"}
            </button>

            <p
              style={{
                textAlign: "center",
                color: "#bbb",
                fontSize: "0.75rem",
                marginTop: "16px",
              }}
            >
              * Pflichtfelder
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
